import { NavigationGuard } from 'vue-router'

import { AuthenticationService } from '../services'
import { store } from '../store'

export const authGuard: NavigationGuard = (to, from, next) => {
  // Ensure user is logged in
  if (!AuthenticationService.isAuthenticated) {
    console.error('Routing | Not authenticated → Redirecting to /login')
    window.location.href = '/login.html?referrer=spa/dashboards'
    return
  }

  // Ensure user has access right while trying to access messenger
  if (!store.state.user.access.message_channel && to.name === 'messenger') {
    console.info('Routing | No rights to acces Messenger-Module → Redirecting to /dashboards')
    next('dashboards')
    return
  }

  // Ensure user has access right while trying to access dashboards
  if (!store.state.user.access.dashboard && to.name === 'dashboards') {
    if (store.state.user.access.message_channel) {
      console.info('Routing | No rights to acces Messenger-Module → Redirecting to /messenger')
      next('messenger')
      return
    }

    console.info('Routing | No rights to acces Messenger-Module → Redirecting to /')
    window.location.href = '/'
    return
  }

  next()
}
